export const timeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
